import React from 'react';
import { TitleCase } from '../../utils/TextTransform';

const ErrorPicker = ({ error }) => {
    return (
        <div className="oi-backend-error" style={{ display: error ? 'block' : 'none' }}>
            {/* eslint-disable-next-line no-undef */}
            {TitleCase(error || ' ')}
        </div>
    );
};

export default ErrorPicker;
